import { render, staticRenderFns } from "./ExportChatModal.vue?vue&type=template&id=bcf9fc3c"
import script from "./ExportChatModal.vue?vue&type=script&lang=js"
export * from "./ExportChatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports